export default __webpack_public_path__ + "static/media/regulatory--no-skiing--g1.655b7641.png";